<template>
  <div class="widget-container" :class="{ 'widget-container--mobile': mobile }">
    <!-- Fixed header -->
    <div class="widget-header">
      <div class="widget-header__inner">
        <span class="widget-title">Personas Atendidas <span class="widget-title--small">Hoy</span></span>
      </div>
      <v-divider></v-divider>
    </div>

    <!-- Content -->
    <div class="widget-body widget-body--centered">
      <div class="attended-content" :class="{ 'attended-content--mobile': mobile }">
        <div class="attended-icon">
          <v-icon disabled :size="mobile ? 60 : 110">mdi-ticket-outline mdi-rotate-90</v-icon>
        </div>
        <div class="attended-info">
          <template v-if="TicketsInfoBySpace[0]">
            <p class="attended-count" :class="{ 'attended-count--mobile': mobile }">{{TicketsInfoBySpace[0].ticketsClosed}}</p>
            <p class="attended-label" :class="{ 'attended-label--mobile': mobile }">Tiempo medio</p>
            <p class="attended-duration" :class="{ 'attended-duration--mobile': mobile }">{{TicketsInfoBySpace[0].meanDuration}} <span class="attended-duration__unit" :class="{ 'attended-duration__unit--mobile': mobile }">s</span></p>
          </template>
          <template v-else>
            <p class="attended-count" :class="{ 'attended-count--mobile': mobile }">--</p>
            <p class="attended-empty" :class="{ 'attended-empty--mobile': mobile }">--</p>
          </template>
        </div>
      </div>
      <div class="widget-spacer"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "widgetTotalTicketsBySpace",
  data: () => ({
        mobile: false,
  }),
  components: {},
  computed: {
    ...mapState("queues", [
      "spaceSelected",
      "allResouces",
      "TicketsInfoBySpace"
    ]),
    ...mapState("app", ["actualProject"]),
    // headersStands() {
    //   return [
    //     { text: "icon", value: "icon", align: "start" },
    //     { text: "nombre", value: "name" },
    //   ];
    // },
    // arrStands() {
    //   let allResouces = this.allResouces;

    //   allResouces = allResouces.filter(
    //       resource => resource.space == this.spaceSelected.idSpace
    //     );

    //   return allResouces.map((resource) => {
    //     return {
    //       ...resource,
    //       icon: "mdi-store",
    //     };
    //   });
    // },
  },
  methods: {
    // ...mapMutations("queues", [
    //   "spaceActions",
    // ]),
    // ...mapActions("queues", [
    //   "getTicketStore",
    //   "getTicketAttended"
    // ]),
    // async goResource(resource) {
    //   this.spaceActions(resource);
    //   await this.getTicketStore(resource.idResource);
    //   await this.getTicketAttended(resource.idResource);
    //   if (this.mobile == true) {
    //           this.$router.push({
    //     name: "GeneralStandTurnMobile",
    //     params: { idSpace: resource },
    //   });
    //   }else{
    //   this.$router.push({
    //     name: "GeneralStandTurn",
    //     params: { idSpace: resource },
    //   });
    //   }

    // },
  },
  created() {
     
     var mobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
      }
    };
        
    if(mobile.any() != null){
        this.mobile = true
    }else{
      this.mobile = false
    }
  },
  mounted() {},
  destroyed() {},
};
</script>

<style scoped>
.widget-container {
  display: flex;
  flex-direction: column;
  height: calc(36vh);
  overflow: hidden;
}
.widget-container--mobile {
  height: auto;
  max-height: calc(36vh);
}
.widget-header {
  flex-shrink: 0;
  padding: 0 16px;
}
.widget-header__inner {
  display: flex;
  align-items: center;
  padding: 12px 0;
}
.widget-title {
  color: #777;
  font-size: 18px;
}
.widget-title--small {
  font-size: 12px;
}
.widget-body {
  flex: 1;
  overflow: auto;
  margin: 0 8px 0 0;
  padding: 0 8px 16px 16px;
}
.widget-body--centered {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.widget-spacer {
  height: 16px;
}
.attended-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.attended-icon,
.attended-info {
  flex-shrink: 0;
}
.attended-count {
  font-size: 8vh;
  color: #777;
  margin: 0;
  line-height: 1;
}
.attended-count--mobile {
  font-size: 40px;
}
.attended-label {
  font-size: 1.5vh;
  color: #777;
  margin: 8px 0 0 0;
}
.attended-label--mobile {
  font-size: 11px;
  margin: 4px 0 0 0;
}
.attended-duration {
  font-size: 2.2vh;
  color: #777;
  margin: 0;
}
.attended-duration--mobile {
  font-size: 14px;
}
.attended-duration__unit {
  font-size: 1.5vh;
}
.attended-duration__unit--mobile {
  font-size: 11px;
}
.attended-empty {
  font-size: 1.7vh;
  color: #777;
  margin: 0;
}
.attended-empty--mobile {
  font-size: 12px;
}
>>> td {
  border: none !important;
}
>>> th {
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/components/widgetTotalTicketsBySpace.vue